import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[appNoSpaces]',
  standalone: true
})
export class NoSpacesDirective {

  constructor(
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  @HostListener('input')
  onInput(): void {

    const input = this.elementRef.nativeElement;

    const originalValue = input.value;
    const sanitizedValue = originalValue.replace(/\s/g, '');

    if (originalValue !== sanitizedValue) {
      input.value = sanitizedValue;

      input.dispatchEvent(
        new Event('input', { bubbles: true })
      );
    }
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {

    if (event.key === ' ') {
      event.preventDefault();
    }
  }
}